import { useParams } from 'react-router-dom';
import config from '../../../../application/config/config';
import CustomDataGrid from '../../core/Util/DataGrid/CustomDataGrid';
import Fetch from '../../../util/core/Fetch';

function ExampleDataGrid() {

    const loadData = async() => {
        const columns = [
            {
                key: 'id',
                name: 'Id'
            },
            {
                key: 'name',
                name: 'nome'
            }
        ]

        let rows = [];

        for(let i=1;i<100;i++){
            rows.push({
                id: i,
                name: 'Teste '+1
            })
        }
        return {
            columns: columns,
            rows: rows
        };
    }
    return (
        
        <div style={{padding:'10px'}}>
            <CustomDataGrid loadData={loadData}/>
        </div>
    );
}
export default ExampleDataGrid;
